import React, { useEffect, useState } from "react";
import DatamapsIndia from "react-datamaps-india";
import ApiService from "../../api/ApiService";
import { useTranslation } from "react-i18next";
import { Table } from "react-bootstrap";
import html2canvas from "html2canvas";

export default function IndiaMap({ selectedEvent }) {
  const [statePointsData, setStatePointsData] = useState([]);
  console.log("statePointsData",statePointsData);
  
  const [isMapVisible, setIsMapVisible] = useState(true);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const { t } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mapHeight = windowWidth > 768 ? "900px" : "300px";

  const getStateWisePointsForMap = async () => {
    setStatePointsData([]);
    try {
      const res = await ApiService.getStateWisePointsForMap(selectedEvent);
      if (res.data.length > 0) {
        const apiDataMap = res.data.reduce((acc, { state_name, value, pointsValue }) => {
          acc[state_name.toLowerCase()] = { value, pointsValue };
          return acc;
        }, {});        
        const finalData = Object.entries(apiDataMap).map(
          ([state_name, { value, pointsValue }]) => ({
            state_name,
            value,
            pointsValue,
          })
        );        
        finalData.sort((a, b) => Number(b.value) - Number(a.value));
        setStatePointsData(finalData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownload = () => {
    setIsButtonVisible(false);
    setTimeout(() => {
      html2canvas(document.querySelector("#state-wise-points")).then(
        (canvas) => {
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = "state-wise-harinam-count.png";
          link.click();
          setIsButtonVisible(true);
        }
      );
    }, 1000);
  };

  const handleMapDownload = () => {
    setIsButtonVisible(false);
    setTimeout(() => {
      html2canvas(document.querySelector("#state-wise-card")).then((canvas) => {
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = "state-wise-harinam-map.png";
        link.click();
        setIsButtonVisible(true);
      });
    }, 1000);
  };

  useEffect(() => {
    getStateWisePointsForMap();
  }, [selectedEvent]);

  function capitalizeFirstLetter(phrase) {
    if (!phrase) return phrase;
    return phrase
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  return (
    <>
      {statePointsData.length > 0 && (
        <div className="user-welcome-card" id="state-wise-card">
          <div className="d-flex justify-content-between">
            <h2 className="India-Map-Heading">
              {isMapVisible
                ? t("State Wise Harinaam Sankirtan Count")
                : t("State Wise Rank")}
            </h2>
            <div className="d-inline-flex align-items-center">
              <span
                className="button-text-download me-3"
                onClick={() => setIsMapVisible(!isMapVisible)}
              >
                {isMapVisible ? t("View Table") : t("View Map")}
              </span>

              {isMapVisible && isButtonVisible && (
                <span
                  className="button-text-download"
                  onClick={handleMapDownload}
                >
                  {t("Download")}
                </span>
              )}

              {!isMapVisible && isButtonVisible && (
                <span className="button-text-download" onClick={handleDownload}>
                  {t("Download")}
                </span>
              )}
            </div>
          </div>

          {isMapVisible ? (
            <div className="map-container" style={{ height: mapHeight }}>
              <DatamapsIndia
                regionData={statePointsData.reduce((acc, item) => {
                  acc[capitalizeFirstLetter(item.state_name)] = {
                    value: Math.ceil(item.value),
                  };
                  return acc;
                }, {})}
                hoverComponent={({ value }) => (
                  <div className="custom-tooltip">
                    <p>{t(value.name)}</p>
                    <p>
                      {t("Count")} :{" "}
                      {value?.value
                        ? Math.ceil(value.value).toLocaleString("en-IN")
                        : 0}
                    </p>
                  </div>
                )}
                mapLayout={{
                  legendTitle: t("Count"),
                  startColor: "#fff4df",
                  endColor: "#ffa652",
                  minValue: Math.min(
                    ...statePointsData.map((s) => Math.ceil(s.value))
                  ),
                  maxValue: Math.max(
                    ...statePointsData.map((s) => Math.ceil(s.value))
                  ),
                  hoverTitle: "Count",
                  noDataColor: "#f5f5f5",
                  borderColor: "#8D8D8D",
                  hoverColor: "#E6A632",
                  hoverBorderColor: "green",
                }}
              />
              <p className="map-heading">
                <b>{t("Note")}</b>:{" "}
                {t(
                  "The darker color indicates higher Sankirtan count, while lighter color indicates lower Sankirtan count."
                )}
                .
              </p>
            </div>
          ) : (
            <div
              className="history-table mt-3"
              id="state-wise-points"
              style={{ maxHeight: "830px", overflowY: "auto" }}
            >
              <Table responsive className="table history-custom-table">
                <thead>
                  <tr className="text-start sticky-header">
                    <th
                      className="text-start table-row-header"
                      style={{ paddingLeft: "20px", paddingRight: "70px" }}
                    >
                      {t("Rank")}
                    </th>
                    <th className="table-row-header text-start transaction-cell">
                      {t("State Name")}
                    </th>
                    <th
                      className="text-end table-row-header"
                      style={{ paddingRight: "20px" }}
                    >
                      {t("Points")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {statePointsData.map((item, index) => (
                    <tr key={index}>
                      <td
                        className="text-start"
                        style={{ paddingLeft: "20px", paddingRight: "70px" }}
                      >
                        {index + 1}
                      </td>
                      <td className="history-cell-text">
                        {t(capitalizeFirstLetter(item.state_name))}
                      </td>
                      <td
                        className="text-end history-cell-text"
                        style={{ paddingRight: "20px" }}
                      >
                        {Math.ceil(item.pointsValue).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </div>
      )}
    </>
  );
}
